import React from 'react';
import NewsBlockSkeleton from 'app/components/competitionModule/news/NewsBlockSkeleton';
import HeaderSkeleton from 'app/components/competitionModule/header/HeaderSkeleton';
import MatchesSkeleton from 'app/components/competitionModule/matches/MatchesSkeleton';
import { ModuleWrapper, Separator } from 'app/components/competitionModule/common/styles';
import { SkeletonAnimation } from 'app/types/SkeletonAnimation';
import LinkSkeleton from 'app/components/competitionModule/link/LinkSkeleton';
export default function LoadingSkeleton(_ref) {
  let {
    animation = SkeletonAnimation.Pulse
  } = _ref;
  return /*#__PURE__*/React.createElement(ModuleWrapper, {
    "data-sentry-element": "ModuleWrapper",
    "data-sentry-component": "LoadingSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(HeaderSkeleton, {
    animation: animation,
    "data-sentry-element": "HeaderSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(Separator, {
    "data-sentry-element": "Separator",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(MatchesSkeleton, {
    animation: animation,
    "data-sentry-element": "MatchesSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(NewsBlockSkeleton, {
    animation: animation,
    "data-sentry-element": "NewsBlockSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }), /*#__PURE__*/React.createElement(LinkSkeleton, {
    animation: animation,
    "data-sentry-element": "LinkSkeleton",
    "data-sentry-source-file": "LoadingSkeleton.tsx"
  }));
}